// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"68e8d2ce","265":"c19984b3","270":"f0bed883"}[chunkId] + ".chunk.js";
};